import React from 'react'

export default function UserShow() {
    
  return (
    <div>
        id :
    </div>
  )
}
